import { NarvarStatusCode } from '../../../../../__generated__/loma';

export const PREVIEW_LOCAL_DELIVERY_ORDER_PLACED =
  'PREVIEW_LOCAL_DELIVERY_ORDER_PLACED';
export const PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS =
  'PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS';
export const PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY =
  'PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY';
export const PREVIEW_LOCAL_DELIVERY_DELIVERED =
  'PREVIEW_LOCAL_DELIVERY_DELIVERED';
export const PREVIEW_LOCAL_DELIVERY_EXCEPTION =
  'PREVIEW_LOCAL_DELIVERY_EXCEPTION';

export const PREVIEW_HPU_SCHEDULED = 'PREVIEW_HPU_SCHEDULED';
export const PREVIEW_HPU_PICKUP_IN_PROGRESS = 'PREVIEW_HPU_PICKUP_IN_PROGRESS';
export const PREVIEW_HPU_PICKED_UP = 'PREVIEW_HPU_PICKED_UP';
export const PREVIEW_HPU_EXCEPTION = 'PREVIEW_HPU_EXCEPTION';

export const PREVIEW_MAPVIEW_ON_ITS_WAY = 'PREVIEW_MAPVIEW_ON_ITS_WAY';
export const PREVIEW_MAPVIEW_DELIVERED = 'PREVIEW_MAPVIEW_DELIVERED';
export const PREVIEW_MAPVIEW_EXCEPTION = 'PREVIEW_MAPVIEW_EXCEPTION';

export type stepperKeys =
  | typeof PREVIEW_LOCAL_DELIVERY_DELIVERED
  | typeof PREVIEW_LOCAL_DELIVERY_EXCEPTION
  | typeof PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY
  | typeof PREVIEW_LOCAL_DELIVERY_ORDER_PLACED
  | typeof PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS
  | typeof PREVIEW_HPU_SCHEDULED
  | typeof PREVIEW_HPU_PICKUP_IN_PROGRESS
  | typeof PREVIEW_HPU_PICKED_UP
  | typeof PREVIEW_HPU_EXCEPTION
  | typeof PREVIEW_MAPVIEW_ON_ITS_WAY
  | typeof PREVIEW_MAPVIEW_DELIVERED
  | typeof PREVIEW_MAPVIEW_EXCEPTION;

export type StepperInfo = {
  activeStep: number;
  partialFill?: boolean;
  partialWidth?: string;
  exception?: boolean;
};

export const getSteps = (
  statusCode: NarvarStatusCode,
): Record<string, StepperInfo> => ({
  PREVIEW_LOCAL_DELIVERY_ORDER_PLACED: {
    activeStep: 0,
    partialFill: true,
    partialWidth: '25%',
  },
  PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS: {
    activeStep: 1,
    partialFill: true,
    partialWidth: statusCode === 'SHPD_SDD_201' ? '45%' : '80%',
  },
  PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY: {
    activeStep: 2,
    partialFill: true,
    partialWidth: '50%',
  },
  PREVIEW_LOCAL_DELIVERY_DELIVERED: {
    activeStep: 3,
  },
  PREVIEW_LOCAL_DELIVERY_EXCEPTION: {
    activeStep: -1,
    exception: true,
  },
  PREVIEW_HPU_SCHEDULED: {
    activeStep: 0,
    partialFill: true,
    partialWidth: '50%',
  },
  PREVIEW_HPU_PICKUP_IN_PROGRESS: {
    activeStep: 1,
    partialFill: true,
    partialWidth: '50%',
  },
  PREVIEW_HPU_PICKED_UP: {
    activeStep: 2,
  },
  PREVIEW_HPU_EXCEPTION: {
    activeStep: -1,
    exception: true,
  },
  PREVIEW_MAPVIEW_ON_ITS_WAY: {
    activeStep: 0,
    partialFill: true,
    partialWidth: '50%',
  },
  PREVIEW_MAPVIEW_DELIVERED: {
    activeStep: 1,
  },
  PREVIEW_MAPVIEW_EXCEPTION: {
    activeStep: -1,
    exception: true,
  },
});
